import { JSX, useState } from "react";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

interface TypeaheadMultiselectDropdownProps<T> {
  containerClassName?: string,
  customSelectInputText?: string;
  descriptiveText?: string;
  descriptiveTextClassname?: string;
  disabled?: boolean,
  items: DropdownItem<T>[];
  isLoading?: boolean;
  label: string | JSX.Element;
  onSelectionChanged?: (selectedItems: DropdownItem<T>[]) => void;
  showTooltipOnOverflow?: boolean;
  selectedItems: DropdownItem<T>[];
  testId: string;
  validationTooltipContent?: string | JSX.Element;
}

const TypeaheadMultiselectDropdown = <T,>(props: TypeaheadMultiselectDropdownProps<T>): JSX.Element => {
  const [searchText, setSearchText] = useState("");
  const [filteredItems, setFilteredItems] = useState<DropdownItem<T>[]>([]);

  const onSearchTextChange = (searchText: string) => {
    setSearchText(searchText);
    const filtered = searchText === "" ? [] : props.items.filter(
      option => option.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredItems(filtered);
  };

  const displayItems = !!searchText ? filteredItems : props.selectedItems.concat(filteredItems);

  return (
    <MultiselectDropdown
      autofocusSearch={true}
      containerClassName={props.containerClassName}
      customSelectInputText={props.customSelectInputText}
      descriptiveText={props.descriptiveText}
      descriptiveTextClassname={props.descriptiveTextClassname}
      disabled={props.disabled}
      hideSelectAll={displayItems.length === 0}
      items={displayItems}
      isLoading={props.isLoading}
      label={props.label}
      onSelectionChanged={props.onSelectionChanged}
      onSearchTextChange={onSearchTextChange}
      selectAllAppliesToAllItems={false}
      selectedItems={props.selectedItems}
      showTooltipOnOverflow={props.showTooltipOnOverflow}
      testId={props.testId}
      validationTooltipContent={props.validationTooltipContent}
    />
  )
}

export default TypeaheadMultiselectDropdown;
